<template>
  <q-page padding>

    <FirmaDialog :empresa_id="1" :pedido_id="10323"/>

  </q-page>
</template>

<script>
import FirmaDialog from '@/components/FirmaDialog.vue'
export default {
  components: {
    FirmaDialog
  },
  data: () => {
    return {
    }
  }
}
</script>

<style lang="scss">

</style>